import React, { CSSProperties, FC, HTMLAttributes } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "@infobis/ui-styles-utils";
import Container from "@elements/container/Container";
import { Color, Height, Width } from "@baseTypes/baseType";
import Tx from "@baseTypes/naming";
import st from "./headerDashboardLayout.module.scss"
import cn from "classnames";
import DateSelector from "@layouts/headerDashboardLayout/components/DateSelector/DateSelector";
import Filters from "@layouts/headerDashboardLayout/components/Filters/Filters";

interface HeaderDashboardLayout extends HTMLAttributes<HTMLDivElement>{
    children?: React.ReactNode
    cropVisible?: boolean
    title?: Tx | string
    goBackButtonVisible?: boolean
    contentContainerWidth?: Width
    color?: Color
    headerClassName?: string
    outerContainerClassName?: string
    scrollWithBackground?: boolean
    containerStyles?: CSSProperties
}

const HeaderDashboardLayout: FC<HeaderDashboardLayout> = (props) => {
    const {
        children,
        title,
        cropVisible = true,
        goBackButtonVisible = true,
        contentContainerWidth,
        style,
        className,
        color = Color.LightGray,
        headerClassName,
        scrollWithBackground,
        containerStyles
    } = props
    const navigate = useNavigate()
    const location = useLocation()
    const isIndexPath = location.pathname === '/'

    return (
        <Container
            color={color}
            height={Height.Full}
            style={{ overflow: 'auto' }}
            className={cn(scrollWithBackground && st['scroll-with-background'])}
        >
            <Container
                height={Height.Full}
                className={cn(st.container, className)}
                width={contentContainerWidth}
                style={style}
            >
                <Header backButtonVisible={!isIndexPath && goBackButtonVisible}
                        style={{ marginBottom: 24 }}
                        onBackButtonClick={() => navigate(-1)}
                        title={title}
                        extra={cropVisible &&
                            <div className={st['filters']}>
                                <DateSelector />
                                <Filters />
                            </div>
                        }
                />
                <Container height={Height.Auto} style={containerStyles}>
                    {children}
                </Container>
            </Container>
        </Container>

    )
}
export default HeaderDashboardLayout;